import { Outlet } from 'react-router-dom';
import { AppSidebar } from '@/components/app-sidebar.js';
import { Separator } from '@/components/ui/separator';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar.js';
import { TopNavigation } from '@/app/layout/TopNavigation.jsx';
import { DocsLogo } from '@/shared/ui/DocsLogo.jsx';

import { isInIframe } from '@/shared/contexts/EmbedAuthContext';

export const Layout = () => {
  const show = localStorage.getItem('show');
  const userType = localStorage.getItem('userType');

  // strictly hide sidebar if in iframe
  const isEmbed = isInIframe() || userType === 'iframe';

  // condition that decides when to show sidebar-related UI
  const shouldShowSidebar = !isEmbed && (show === 'true' || userType === 'admin' || userType === 'org_admin');

  return (
    <>
      <SidebarProvider>
        {shouldShowSidebar && <AppSidebar />}
        <SidebarInset>
          {/* h-dvh (not h-screen): tracks the visible viewport under mobile
              browser chrome; inside the tc-mall iframe dvh == the frame box. */}
          <div className="flex flex-1 flex-col h-dvh overflow-auto bg-background">
            {/* Phone-only opener for the shadcn sidebar Sheet — the sidebar
                has had mobile drawer support all along, just no trigger. */}
            {shouldShowSidebar && (
              <div className="sticky top-0 z-10 flex items-center gap-2 border-b border-border bg-card px-2 py-1.5 md:hidden">
                <SidebarTrigger />
                <DocsLogo markSize={18} />
              </div>
            )}
            {/* isEmbed, not userType==='iframe': the tc-mall SET_TOKEN flow
                never writes userType, so keying on localStorage alone left the
                iframe with no navigation at all on a clean session. */}
            {isEmbed && (
              <div className="w-full bg-card border-b border-border sticky top-0 z-10">
                <TopNavigation />
              </div>
            )}
            <div className={`flex-1 bg-background min-h-0`}>
              <Outlet />
            </div>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </>
  );
};
